import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/IQAC-AQARReports.css';

const aqarReports = [
  {
    year: '2020–21',
    collegeUrl: '/pdfs/AQAR-2020-21.pdf',
    collegeLabel: 'SMC AQAR 2020–21',
  },
  {
    year: '2021–22',
    collegeUrl: '/pdfs/AQAR-2021-22.pdf',
    collegeLabel: 'SMC AQAR 2021–22',
  },
  {
    year: '2022–23',
    collegeUrl: '/pdfs/AQAR-2022-23.pdf',
    collegeLabel: 'SMC AQAR 2022–23',
  },
  {
    year: '2023–24',
    collegeUrl: '/pdfs/AQAR-2023-24.pdf',
    collegeLabel: 'SMC AQAR 2023–24',
  },
];

const IQACReports = () => {
  const [fade, setFade] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setFade(true), 100);
  }, []);

  return (
    <>
      <Navbar />
      <section className='section-wrapper-no-text-align'>
      <div className={`reports-container ${fade ? 'fade-in' : ''}`}>
        <section className="reports-header">
          <h4>Shri Mulikadevi Mahavidyalaya, Nighoj</h4>
          <h2>IQAC Annual Quality Assurance Reports (AQAR)</h2>
          <p>
            Find downloadable AQARs submitted by IQAC, reflecting progress on curricular aspects, teaching-learning, infrastructure, and best practices. Also view a sample from Fergusson College for reference.
          </p>
        </section>
        <section className="reports-list">
          {aqarReports.map((rep, i) => (
            <div key={i} className="report-card animate-card">
              <h3>{rep.year}</h3>
              <div className="btn-group">
                <a href={rep.collegeUrl} target="_blank" rel="noopener noreferrer" className="report-btn">
                  {rep.collegeLabel}
                </a>
              </div>
            </div>
          ))}
        </section>
      </div>
      </section>
      <Footer />
    </>
  );
};

export default IQACReports;
